<template>
  <div class="brand-review-result">
    <div v-if="isApproved === null" class="brand-review-result-inreview">
      <div class="brand-review-result-title">Thanks!</div>
      <div class="brand-review-result-content">Thanks!</div>
      <div class="brand-review-result-content">Your responses will be reviewed by someone on the ShopVidi team</div>
      <div class="brand-review-result-content">The review is expected to be completed within 48 hours (working days,extended on holidays).</div>
      <div class="brand-review-result-content">Our sales team will get in touch with you.</div>
      <a class="brand-review-action" target="_blank" href="https://www.shopvidi.com">Go to ShopVidi</a>
    </div>
    <div v-if="isApproved === false" class="brand-review-result-declined">
      <div class="brand-review-result-title">Sorry!</div>
      <div class="brand-review-result-content">Thank you for submitting your registration application on our platform. After careful review, we regret to inform you that your registration has not been approved. If you wish to explore further collaboration opportunities, please feel free to contact the ShopVidi team.</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isApproved: {
      type: Boolean,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.brand-review-result-declined{
  width: 50%;
  margin:0 auto;
}
.brand-review-result-title{
  font-size: 24px;
  font-family: Satoshi-Regular;
  color: #262B2F;
  line-height: 138px;
  text-align: center;
}
.brand-review-result-content{
  color: #262B2F;
  line-height: 30px;
  font-size: 14px;
}
.brand-review-action{
  height: 50px;
  background: #262B2F;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  margin: 0 auto;
  color: #FFFFFF;
  margin-top: 50px;
  cursor: pointer;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/brand-review/brand-review-result.vue